import React from 'react';
import * as styles from './otBoutique.module.scss';
import { OtTemplateQuery } from '../../../graphql-types';
import { usePageContext } from '../../hooks/contexts/usePageContext';

interface IOtBoutiqueProps {
  ot?: OtTemplateQuery['ingenieOt'];
}

export const OtBoutique = ({ ot }: IOtBoutiqueProps) => {
  const { lang } = usePageContext();

  const carouselItems: any = ot?.medias?.map((media) => {
    const alt = media?.attributs?.find((attr) => attr?.type === 'ALT');
    return {
      _key: media?.id,
      url: media?.url,
      alt,
      type: media?.type,
    };
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        <img key={carouselItems[0]?._key} src={carouselItems[0]?.url} alt={carouselItems[0]?.alt} />
      </div>
      <div className={styles.content}>
        <h1>{ot?.libelle?.fr}</h1>
        <div className={styles.widgetPrice}>
          Prix <span>Réduction</span>
        </div>
        <section className={styles.widgetCart}>
          <h6>Quantité :</h6>
        </section>
        <section>
          <h6>Description :</h6>
          <p dangerouslySetInnerHTML={{ __html: ot?.descriptifs?.[0]?.contenu?.[lang] }}></p>
        </section>
      </div>
    </div>
  );
};
